import { apiPaths, apiActions } from "./db"

export const enumRoles = { ADMIN: 1, AGENT: 2, BAN: 99 } /* SHOULD_CHANGE */

const enumPermissionActions = { ...apiActions }
const EPA = enumPermissionActions

export const enumPermissionModules = { ...apiPaths }
const EPM = enumPermissionModules

export const enumPermissions = {
  // Admin - Permissions
  ADMIN_PERMISSIONS_GET: `${EPM.ADMIN_PERMISSIONS}/${EPA.GET}`,
  ADMIN_PERMISSIONS_UPDATE: `${EPM.ADMIN_PERMISSIONS}/${EPA.UPDATE}`,
  // Admin - Users
  ADMIN_USERS_LIST: `${EPM.ADMIN_USERS}/${EPA.LIST}`,
  ADMIN_USERS_DELETE: `${EPM.ADMIN_USERS}/${EPA.DELETE}`,
  ADMIN_USERS_CREATE: `${EPM.ADMIN_USERS}/${EPA.CREATE}`,
  ADMIN_USERS_UPDATE: `${EPM.ADMIN_USERS}/${EPA.UPDATE}`,
  // Admin - EMPLOYEES
  ADMIN_EMPLOYEES_LIST: `${EPM.ADMIN_EMPLOYEES}/${EPA.LIST}`,
  ADMIN_EMPLOYEES_CREATE: `${EPM.ADMIN_EMPLOYEES}/${EPA.CREATE}`,
  ADMIN_EMPLOYEES_UPDATE: `${EPM.ADMIN_EMPLOYEES}/${EPA.UPDATE}`,
  ADMIN_EMPLOYEES_DELETE: `${EPM.ADMIN_EMPLOYEES}/${EPA.DELETE}`,
  ADMIN_EMPLOYEES_FILES: `${EPM.ADMIN_EMPLOYEES}/${EPA.FILES}`,
  ADMIN_EMPLOYEES_IMAGE: `${EPM.ADMIN_EMPLOYEES}/${EPA.IMAGE}`,

  ADMIN_COMPANIES_LIST: `${EPM.ADMIN_COMPANIES}/${EPA.LIST}`,
  ADMIN_COMPANIES_CREATE: `${EPM.ADMIN_COMPANIES}/${EPA.CREATE}`,
  ADMIN_COMPANIES_UPDATE: `${EPM.ADMIN_COMPANIES}/${EPA.UPDATE}`,
  ADMIN_COMPANIES_DELETE: `${EPM.ADMIN_COMPANIES}/${EPA.DELETE}`,
  //Admin - Forms templates
  ADMIN_FORMS_TEMPLATES_LIST: `${EPM.ADMIN_FORMS_TEMPLATES}/${EPA.LIST}`,
  ADMIN_FORMS_TEMPLATES_CREATE: `${EPM.ADMIN_FORMS_TEMPLATES}/${EPA.CREATE}`,
  ADMIN_FORMS_TEMPLATES_UPDATE: `${EPM.ADMIN_FORMS_TEMPLATES}/${EPA.UPDATE}`,
  ADMIN_FORMS_TEMPLATES_DELETE: `${EPM.ADMIN_FORMS_TEMPLATES}/${EPA.DELETE}`,
  ADMIN_FORMS_TEMPLATES_GET_LINK: `${EPM.ADMIN_FORMS_TEMPLATES}/${EPA.GET_LINK}`,
  //Admin - Forms submissions
  ADMIN_FORMS_SUBMISSIONS_LIST: `${EPM.ADMIN_FORMS_SUBMISSIONS}/${EPA.LIST}`,
  ADMIN_FORMS_SUBMISSIONS_GET: `${EPM.ADMIN_FORMS_SUBMISSIONS}/${EPA.GET}`,
  //Admin - Working sites
  ADMIN_WORKING_SITES_LIST: `${EPM.ADMIN_WORKING_SITES}/${EPA.LIST}`,
  ADMIN_WORKING_SITES_CREATE: `${EPM.ADMIN_WORKING_SITES}/${EPA.CREATE}`,
  ADMIN_WORKING_SITES_UPDATE: `${EPM.ADMIN_WORKING_SITES}/${EPA.UPDATE}`,
  ADMIN_WORKING_SITES_DELETE: `${EPM.ADMIN_WORKING_SITES}/${EPA.DELETE}`,
  //Admin - Working sites planner
  ADMIN_WORKING_SITES_PLANNER_LIST: `${EPM.ADMIN_WORKING_SITES_PLANNER}/${EPA.LIST}`,
  ADMIN_WORKING_SITES_PLANNER_CREATE: `${EPM.ADMIN_WORKING_SITES_PLANNER}/${EPA.CREATE}`,
  ADMIN_WORKING_SITES_PLANNER_CREATE_CONSTANT: `${EPM.ADMIN_WORKING_SITES_PLANNER}/${EPA.CREATE_CONSTANT}`,
  ADMIN_WORKING_SITES_PLANNER_GET: `${EPM.ADMIN_WORKING_SITES_PLANNER}/${EPA.GET}`,
  ADMIN_WORKING_SITES_PLANNER_DELETE: `${EPM.ADMIN_WORKING_SITES_PLANNER}/${EPA.DELETE}`,
  ADMIN_WORKING_SITES_PLANNER_UPDATE: `${EPM.ADMIN_WORKING_SITES_PLANNER}/${EPA.UPDATE}`,
  //Admin - Employees planner
  ADMIN_EMPLOYEES_PLANNER_LIST: `${EPM.ADMIN_EMPLOYEES_PLANNER}/${EPA.LIST}`,
  //Admin - Working hours
  ADMIN_WORKING_HOURS_LIST: `${EPM.ADMIN_WORKING_HOURS}/${EPA.LIST}`,
  ADMIN_WORKING_HOURS_GET: `${EPM.ADMIN_WORKING_HOURS}/${EPA.GET}`,
  ADMIN_WORKING_HOURS_UPDATE: `${EPM.ADMIN_WORKING_HOURS}/${EPA.UPDATE}`,
  ADMIN_WORKING_HOURS_CREATE: `${EPM.ADMIN_WORKING_HOURS}/${EPA.CREATE}`,
  ADMIN_WORKING_HOURS_TOTALS: `${EPM.ADMIN_WORKING_HOURS}/${EPA.TOTALS}`,
  //Admin - Working hours submissions
  ADMIN_WORKING_HOURS_SUBMISSIONS_LIST: `${EPM.ADMIN_WORKING_HOURS_SUBMISSIONS}/${EPA.LIST}`,
  ADMIN_WORKING_HOURS_SUBMISSIONS_GET: `${EPM.ADMIN_WORKING_HOURS_SUBMISSIONS}/${EPA.GET}`,
  ADMIN_WORKING_HOURS_SUBMISSIONS_UPDATE: `${EPM.ADMIN_WORKING_HOURS_SUBMISSIONS}/${EPA.UPDATE}`,
  //Admin - Working communes
  ADMIN_COMMUNE_LIST: `${EPM.ADMIN_COMMUNE}/${EPA.LIST}`,
  ADMIN_COMMUNE_CREATE: `${EPM.ADMIN_COMMUNE}/${EPA.CREATE}`,
  ADMIN_COMMUNE_UPDATE: `${EPM.ADMIN_COMMUNE}/${EPA.UPDATE}`,
  ADMIN_COMMUNE_DELETE: `${EPM.ADMIN_COMMUNE}/${EPA.DELETE}`,

  //Admin - Cantons
  ADMIN_CANTONS_LIST: `${EPM.ADMIN_CANTONS}/${EPA.LIST}`,
  ADMIN_CANTONS_CREATE: `${EPM.ADMIN_CANTONS}/${EPA.CREATE}`,
  ADMIN_CANTONS_UPDATE: `${EPM.ADMIN_CANTONS}/${EPA.UPDATE}`,
  ADMIN_CANTONS_DELETE: `${EPM.ADMIN_CANTONS}/${EPA.DELETE}`,

  //Admin - Cities
  ADMIN_CITIES_LIST: `${EPM.ADMIN_CITIES}/${EPA.LIST}`,
  ADMIN_CITIES_CREATE: `${EPM.ADMIN_CITIES}/${EPA.CREATE}`,
  ADMIN_CITIES_UPDATE: `${EPM.ADMIN_CITIES}/${EPA.UPDATE}`,
  ADMIN_CITIES_DELETE: `${EPM.ADMIN_CITIES}/${EPA.DELETE}`,

  //Admin - Cantons holidays
  ADMIN_CANTONS_HOLIDAYS_LIST: `${EPM.ADMIN_CANTONS_HOLIDAYS}/${EPA.LIST}`,
  ADMIN_CANTONS_HOLIDAYS_CREATE: `${EPM.ADMIN_CANTONS_HOLIDAYS}/${EPA.CREATE}`,
  /* ADMIN_CANTONS_HOLIDAYS_UPDATE: `${EPM.ADMIN_CANTONS_HOLIDAYS}/${EPA.UPDATE}`, */
  ADMIN_CANTONS_HOLIDAYS_DELETE: `${EPM.ADMIN_CANTONS_HOLIDAYS}/${EPA.DELETE}`,

  //Admin - Tax scales
  ADMIN_TAX_SCALES_LIST: `${EPM.ADMIN_TAX_SCALES}/${EPA.LIST}`,
  ADMIN_TAX_SCALES_CREATE: `${EPM.ADMIN_TAX_SCALES}/${EPA.CREATE}`,
  ADMIN_TAX_SCALES_UPDATE: `${EPM.ADMIN_TAX_SCALES}/${EPA.UPDATE}`,
  ADMIN_TAX_SCALES_DUPLICATE: `${EPM.ADMIN_TAX_SCALES}/${EPA.DUPLICATE}`,

  //Admin - Tax scales details
  ADMIN_TAX_SCALES_DETAILS_LIST: `${EPM.ADMIN_TAX_SCALES_DETAILS}/${EPA.LIST}`,
  ADMIN_TAX_SCALES_DETAILS_CREATE: `${EPM.ADMIN_TAX_SCALES_DETAILS}/${EPA.CREATE}`,
  ADMIN_TAX_SCALES_DETAILS_UPDATE: `${EPM.ADMIN_TAX_SCALES_DETAILS}/${EPA.UPDATE}`,
  ADMIN_TAX_SCALES_DETAILS_DELETE: `${EPM.ADMIN_TAX_SCALES_DETAILS}/${EPA.DELETE}`,

  //Admin - Tax employees
  ADMIN_TAX_EMPLOYEES_LIST: `${EPM.ADMIN_TAX_EMPLOYEES}/${EPA.LIST}`,
  ADMIN_TAX_EMPLOYEES_CREATE: `${EPM.ADMIN_TAX_EMPLOYEES}/${EPA.CREATE}`,
  ADMIN_TAX_EMPLOYEES_GET: `${EPM.ADMIN_TAX_EMPLOYEES}/${EPA.GET}`,

  //Admin - Employees absence
  ADMIN_EMPLOYEES_ABSENCE_LIST: `${EPM.ADMIN_EMPLOYEES_ABSENCE}/${EPA.LIST}`,
  ADMIN_EMPLOYEES_ABSENCE_CREATE: `${EPM.ADMIN_EMPLOYEES_ABSENCE}/${EPA.CREATE}`,
  ADMIN_EMPLOYEES_ABSENCE_UPDATE: `${EPM.ADMIN_EMPLOYEES_ABSENCE}/${EPA.UPDATE}`,
  ADMIN_EMPLOYEES_ABSENCE_DELETE: `${EPM.ADMIN_EMPLOYEES_ABSENCE}/${EPA.DELETE}`,

  //Admin - Employee notes
  ADMIN_EMPLOYEES_NOTES_LIST: `${EPM.ADMIN_EMPLOYEES_NOTES}/${EPA.LIST}`,
  ADMIN_EMPLOYEES_NOTES_CREATE: `${EPM.ADMIN_EMPLOYEES_NOTES}/${EPA.CREATE}`,
  ADMIN_EMPLOYEES_NOTES_UPDATE: `${EPM.ADMIN_EMPLOYEES_NOTES}/${EPA.UPDATE}`,
  ADMIN_EMPLOYEES_NOTES_DELETE: `${EPM.ADMIN_EMPLOYEES_NOTES}/${EPA.DELETE}`,

  // Admin - Groups
  ADMIN_GROUPS_LIST: `${EPM.ADMIN_GROUPS}/${EPA.LIST}`,
  ADMIN_GROUPS_DELETE: `${EPM.ADMIN_GROUPS}/${EPA.DELETE}`,
  ADMIN_GROUPS_CREATE: `${EPM.ADMIN_GROUPS}/${EPA.CREATE}`,
  ADMIN_GROUPS_UPDATE: `${EPM.ADMIN_GROUPS}/${EPA.UPDATE}`,

  // Admin - report employees
  ADMIN_REPORT_EMPLOYEES: `${EPM.ADMIN_REPORT}/${EPA.EMPLOYEES}`,
  ADMIN_REPORT_WORKING_SITES: `${EPM.ADMIN_REPORT}/${EPA.WORKING_SITES}`,
  ADMIN_REPORT_WORK_TABLE: `${EPM.ADMIN_REPORT}/${EPA.WORK_TABLE}`,

  // Admin - spreadsheats
  ADMIN_SPREADSHEETS_LIST: `${EPM.ADMIN_SPREADSHEETS}/${EPA.LIST}`,
  ADMIN_SPREADSHEETS_DELETE: `${EPM.ADMIN_SPREADSHEETS}/${EPA.DELETE}`,
  ADMIN_SPREADSHEETS_CREATE: `${EPM.ADMIN_SPREADSHEETS}/${EPA.CREATE}`,

  // Admin - Login history
  /* ADMIN_LOGIN_HISTORY_LIST: `${EPM.ADMIN_LOGIN_HISTORY}/${EPA.LIST}`, */

  // Admin - Profile
  /* ADMIN_PROFILE_GET: `${EPM.ADMIN_PROFILE}/${EPA.GET}`,
  ADMIN_PROFILE_UPDATE: `${EPM.ADMIN_PROFILE}/${EPA.UPDATE}`, */

  // Settings
  SETTINGS_GET: `${EPM.SETTINGS}/${EPA.GET}`,
  SETTINGS_UPDATE: `${EPM.SETTINGS}/${EPA.UPDATE}`,
}
const EP = enumPermissions

export const constructedPermissionTree = {
  [EPM.ADMIN_COMPANIES]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_COMPANIES_LIST, EP.ADMIN_COMPANIES_DELETE, EP.ADMIN_COMPANIES_CREATE, EP.ADMIN_COMPANIES_UPDATE]
  },
  [EPM.ADMIN_USERS]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_USERS_LIST, EP.ADMIN_USERS_DELETE, EP.ADMIN_USERS_CREATE, EP.ADMIN_USERS_UPDATE]
  },
  [EPM.ADMIN_COMMUNE]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_COMMUNE_LIST, EP.ADMIN_COMMUNE_DELETE, EP.ADMIN_COMMUNE_CREATE, EP.ADMIN_COMMUNE_UPDATE]
  },
  [EPM.ADMIN_CANTONS]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_CANTONS_LIST, EP.ADMIN_CANTONS_DELETE, EP.ADMIN_CANTONS_CREATE, EP.ADMIN_CANTONS_UPDATE]
  },
  [EPM.ADMIN_CANTONS_HOLIDAYS]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, /* EPA.UPDATE */],
    modified: [EP.ADMIN_CANTONS_HOLIDAYS_LIST, EP.ADMIN_CANTONS_HOLIDAYS_DELETE, EP.ADMIN_CANTONS_HOLIDAYS_CREATE, /* EP.ADMIN_CANTONS_HOLIDAYS_UPDATE */]
  },
  [EPM.ADMIN_CITIES]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_CITIES_LIST, EP.ADMIN_CITIES_DELETE, EP.ADMIN_CITIES_CREATE, EP.ADMIN_CITIES_UPDATE]
  },
  [EPM.ADMIN_EMPLOYEES]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.FILES, EPA.DELETE, EPA.IMAGE],
    modified: [EP.ADMIN_EMPLOYEES_LIST, EP.ADMIN_EMPLOYEES_CREATE, EP.ADMIN_EMPLOYEES_UPDATE, EP.ADMIN_EMPLOYEES_FILES, EP.ADMIN_EMPLOYEES_DELETE, EP.ADMIN_EMPLOYEES_IMAGE]
  },
  [EPM.ADMIN_EMPLOYEES_PLANNER]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_EMPLOYEES_PLANNER_LIST]
  },
  [EPM.ADMIN_PERMISSIONS]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_PERMISSIONS_GET, EP.ADMIN_PERMISSIONS_UPDATE]
  },
  [EPM.ADMIN_FORMS_TEMPLATES]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE, EPA.GET_LINK],
    modified: [EP.ADMIN_FORMS_TEMPLATES_LIST, EP.ADMIN_FORMS_TEMPLATES_DELETE, EP.ADMIN_FORMS_TEMPLATES_CREATE, EP.ADMIN_FORMS_TEMPLATES_UPDATE, EP.ADMIN_FORMS_TEMPLATES_GET_LINK]
  },
  [EPM.ADMIN_FORMS_SUBMISSIONS]: {
    original: [EPA.LIST, EPA.GET],
    modified: [EP.ADMIN_FORMS_SUBMISSIONS_LIST, EP.ADMIN_FORMS_SUBMISSIONS_GET]
  },
  [EPM.ADMIN_WORKING_SITES]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_WORKING_SITES_LIST, EP.ADMIN_WORKING_SITES_DELETE, EP.ADMIN_WORKING_SITES_CREATE, EP.ADMIN_WORKING_SITES_UPDATE]
  },
  [EPM.ADMIN_WORKING_SITES_PLANNER]: {
    original: [EPA.LIST, EPA.CREATE, EPA.GET, EPA.CREATE_CONSTANT, EPA.DELETE, EPA.UPDATE],
    modified: [EP.ADMIN_WORKING_SITES_PLANNER_LIST, EP.ADMIN_WORKING_SITES_PLANNER_CREATE, EP.ADMIN_WORKING_SITES_PLANNER_GET, EP.ADMIN_WORKING_SITES_PLANNER_CREATE_CONSTANT, EP.ADMIN_WORKING_SITES_PLANNER_DELETE, EP.ADMIN_WORKING_SITES_PLANNER_UPDATE]
  },
  [EPM.ADMIN_WORKING_HOURS]: {
    original: [EPA.LIST, EPA.GET, EPA.UPDATE, EPA.TOTALS, EPA.CREATE],
    modified: [EP.ADMIN_WORKING_HOURS_LIST, EP.ADMIN_WORKING_HOURS_GET, EP.ADMIN_WORKING_HOURS_UPDATE, EP.ADMIN_WORKING_HOURS_TOTALS, EP.ADMIN_WORKING_HOURS_CREATE]
  },
  [EPM.ADMIN_WORKING_HOURS_SUBMISSIONS]: {
    original: [EPA.LIST, EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_WORKING_HOURS_SUBMISSIONS_LIST, EP.ADMIN_WORKING_HOURS_SUBMISSIONS_GET, EP.ADMIN_WORKING_HOURS_SUBMISSIONS_UPDATE]
  },
  [EPM.ADMIN_TAX_SCALES]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.DUPLICATE],
    modified: [EP.ADMIN_TAX_SCALES_LIST, EP.ADMIN_TAX_SCALES_CREATE, EP.ADMIN_TAX_SCALES_UPDATE, EP.ADMIN_TAX_SCALES_DUPLICATE]
  },
  [EPM.ADMIN_TAX_SCALES_DETAILS]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_TAX_SCALES_DETAILS_LIST, EP.ADMIN_TAX_SCALES_DETAILS_CREATE, EP.ADMIN_TAX_SCALES_DETAILS_UPDATE, EP.ADMIN_TAX_SCALES_DETAILS_DELETE]
  },
  [EPM.ADMIN_TAX_EMPLOYEES]: {
    original: [EPA.LIST, EPA.CREATE, EPA.GET],
    modified: [EP.ADMIN_TAX_EMPLOYEES_LIST, EP.ADMIN_TAX_EMPLOYEES_CREATE, EP.ADMIN_TAX_EMPLOYEES_GET]
  },
  [EPM.ADMIN_EMPLOYEES_ABSENCE]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_EMPLOYEES_ABSENCE_LIST, EP.ADMIN_EMPLOYEES_ABSENCE_CREATE, EP.ADMIN_EMPLOYEES_ABSENCE_UPDATE, EP.ADMIN_EMPLOYEES_ABSENCE_DELETE]
  },
  [EPM.ADMIN_EMPLOYEES_NOTES]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_EMPLOYEES_NOTES_LIST, EP.ADMIN_EMPLOYEES_NOTES_CREATE, EP.ADMIN_EMPLOYEES_NOTES_UPDATE, EP.ADMIN_EMPLOYEES_NOTES_DELETE]
  },
  [EPM.ADMIN_GROUPS]: {
    original: [EPA.LIST, EPA.DELETE, EPA.CREATE, EPA.UPDATE],
    modified: [EP.ADMIN_GROUPS_LIST, EP.ADMIN_GROUPS_DELETE, EP.ADMIN_GROUPS_CREATE, EP.ADMIN_GROUPS_UPDATE]
  },
  [EPM.ADMIN_REPORT]: {
    original: [EPA.EMPLOYEES, EPA.WORKING_SITES, EPA.WORK_TABLE],
    modified: [EP.ADMIN_REPORT_EMPLOYEES, EP.ADMIN_REPORT_WORKING_SITES, EP.ADMIN_REPORT_WORK_TABLE]
  },
  [EPM.ADMIN_SPREADSHEETS]: {
    original: [EPA.LIST, EPA.CREATE, EPA.DELETE],
    modified: [EP.ADMIN_SPREADSHEETS_LIST, EP.ADMIN_SPREADSHEETS_CREATE, EP.ADMIN_SPREADSHEETS_DELETE]
  },
}

const CPT = constructedPermissionTree

export const adminModules = [
  EPM.ADMIN_USERS,
  EPM.ADMIN_EMPLOYEES,
  EPM.ADMIN_PERMISSIONS,
  EPM.ADMIN_FORMS_TEMPLATES,
  EPM.ADMIN_FORMS_SUBMISSIONS,
  EPM.ADMIN_WORKING_SITES,
  EPM.ADMIN_WORKING_SITES_PLANNER,
  EPM.ADMIN_WORKING_HOURS,
  EPM.ADMIN_WORKING_HOURS_SUBMISSIONS,
  EPM.ADMIN_COMMUNE,
  EPM.ADMIN_CANTONS,
  EPM.ADMIN_CANTONS_HOLIDAYS,
  EPM.ADMIN_CITIES,
  EPM.ADMIN_TAX_SCALES,
  EPM.ADMIN_TAX_SCALES_DETAILS,
  EPM.ADMIN_EMPLOYEES_ABSENCE,
  EPM.ADMIN_EMPLOYEES_NOTES,
  EPM.ADMIN_TAX_EMPLOYEES,
  EPM.ADMIN_EMPLOYEES_PLANNER,
  EPM.ADMIN_GROUPS,
  EPM.ADMIN_REPORT,
  EPM.ADMIN_SPREADSHEETS,
  EPM.ADMIN_COMPANIES
]

export const adminActions = [
  ...CPT[EPM.ADMIN_USERS].modified,
  ...CPT[EPM.ADMIN_EMPLOYEES].modified,
  ...CPT[EPM.ADMIN_PERMISSIONS].modified,
  ...CPT[EPM.ADMIN_FORMS_TEMPLATES].modified,
  ...CPT[EPM.ADMIN_FORMS_SUBMISSIONS].modified,
  ...CPT[EPM.ADMIN_WORKING_SITES].modified,
  ...CPT[EPM.ADMIN_WORKING_SITES_PLANNER].modified,
  ...CPT[EPM.ADMIN_WORKING_HOURS].modified,
  ...CPT[EPM.ADMIN_WORKING_HOURS_SUBMISSIONS].modified,
  ...CPT[EPM.ADMIN_COMMUNE].modified,
  ...CPT[EPM.ADMIN_CANTONS].modified,
  ...CPT[EPM.ADMIN_CANTONS_HOLIDAYS].modified,
  ...CPT[EPM.ADMIN_CITIES].modified,
  ...CPT[EPM.ADMIN_TAX_SCALES].modified,
  ...CPT[EPM.ADMIN_TAX_SCALES_DETAILS].modified,
  ...CPT[EPM.ADMIN_EMPLOYEES_ABSENCE].modified,
  ...CPT[EPM.ADMIN_EMPLOYEES_NOTES].modified,
  ...CPT[EPM.ADMIN_TAX_EMPLOYEES].modified,
  ...CPT[EPM.ADMIN_EMPLOYEES_PLANNER].modified,
  ...CPT[EPM.ADMIN_GROUPS].modified,
  ...CPT[EPM.ADMIN_REPORT].modified,
  ...CPT[EPM.ADMIN_SPREADSHEETS].modified,
  ...CPT[EPM.ADMIN_COMPANIES].modified,
]

export const commonModules = []
export const commonActions = []